// What needs attention on the System overview: NextAdmin `ItemList` rows in a `Card` (demo `/` top channels).
import { Link } from 'react-router-dom';
import { Badge, Card } from '../../../components/ui/index.js';
import type { SystemFinding } from '../../../generated/api/types.gen.js';
import { databaseName } from './DatabaseCard.js';

function targetLink(finding: SystemFinding): { to: string; label: string } {
  if (finding.scope === 'database' && (finding.target === 'app' || finding.target === 'market')) {
    return { to: `/admin/system/databases/${finding.target}`, label: databaseName(finding.target) };
  }
  // An engine job or a data source: its row in the card on this page.
  if (finding.scope === 'engine') return { to: '/admin/system#engine-jobs', label: finding.target };
  if (finding.scope === 'data') return { to: '/admin/system#data-freshness', label: finding.target };
  return { to: `/admin/system/hosts/${encodeURIComponent(finding.target)}`, label: finding.target };
}

export function FindingsCard({ findings }: { findings: SystemFinding[] }) {
  return (
    <Card title="Needs attention" className="xl:col-span-12">
      {findings.length === 0 ? (
        <p className="text-sm text-muted">
          Nothing needs attention: every box, database, engine job and data source is within its limits.
        </p>
      ) : (
        <ul className="divide-y">
          {findings.map((finding) => {
            const target = targetLink(finding);
            return (
              <li
                key={`${finding.code}:${finding.target}:${finding.message}`}
                className="flex items-center gap-3 py-2.5"
              >
                <Badge variant={finding.severity === 'danger' ? 'danger' : 'warning'} dot>
                  {finding.severity === 'danger' ? 'Act now' : 'Watch'}
                </Badge>
                <Link to={target.to} className="text-sm font-medium text-heading hover:underline">
                  {target.label}
                </Link>
                <span className="text-sm text-body">{finding.message}</span>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
